import api from '../config/axiosConfig';

export const ClienteService = {
  buscarPorDNI: async ({ token, numero }) => {
    if (!numero || numero.trim() === '') {
      throw new Error('Número de documento inválido');
    }

    try {
      const response = await api.get(`/services/dni/${numero}`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      return response.data || null;
    } catch (error) {
      console.error('Error en ClienteService.buscarPorDNI:', error);
      throw error;
    }
  },
  buscarPorDocumento: async ({ token, tipoDocumento, numeroDocumento }) => {
    if (!numeroDocumento || numeroDocumento.trim() === '') {
      throw new Error('Ingrese un número válido');
    }

    let endpoint = '';
    if (tipoDocumento === '1') {
      endpoint = `/services/dni/${numeroDocumento}`;
    } else if (tipoDocumento === '4') {
      endpoint = `/services/ruc/${numeroDocumento}`;
    } else {
      throw new Error('Tipo de documento no soportado');
    }

    try {
      const response = await api.get(endpoint, {
        headers: { Authorization: `Bearer ${token}` },
      });

      return response.data || null;
    } catch (error) {
      console.error('Error en ClienteService.buscarPorDocumento:', error);
      throw error;
    }
  },
};
